/**
 * Curated registry of Hyperliquid HyperCore vaults to surface as
 * public-data listings.
 *
 * HyperCore has no clean "list all vaults" info endpoint, so we pin a
 * curated set of addresses and read each via the `vaultDetails` info API
 * (see `fetchPublic.ts`). Seeded from the TradingStrategy dataset's
 * top HyperCore vaults by NAV — HLP (the protocol vault) plus the
 * largest leader/strategy vaults. Extend this list to track more.
 */
export interface HypercoreVaultRegistryEntry {
  /** Vault address (L1), lowercased. */
  address: string
  /** Display name (fallback when `vaultDetails` omits it). */
  name: string
}

export const HYPERCORE_VAULT_REGISTRY: HypercoreVaultRegistryEntry[] = [
  {
    address: '0xdfc24b077bc1425ad1dea75bcb6f8158e10df303',
    name: 'Hyperliquidity Provider (HLP)',
  },
  {
    address: '0xb0a55f13d22f66e6d495ac98113841b2326e9540',
    name: 'HLP Liquidator 2',
  },
  {
    address: '0xd6e56265890b76413d1d527eb9b75e334c0c5b42',
    name: '[ Systemic Strategies ] HyperGrowth',
  },
  { address: '0x1e37a337ed460039d1b15bd3bc489de789768d5e', name: 'Growi HF' },
  {
    address: '0x07fd993f0fa3a185f7207adccd29f7a87404689d',
    name: '[ Systemic Strategies ] L/S Grids',
  },
  { address: '0xc179e03922afe8fa9533d3f896338b9fb87ce0c8', name: 'drkmttr' },
  { address: '0x45e7014f092c5f9c39482caec131346f13ac5e73', name: 'Ultron' },
  {
    address: '0xac26cf5f3c46b5e102048c65b977d2551b72a9c7',
    name: 'Long HYPE & BTC | Short Garbage',
  },
  {
    address: '0x115849ce84370f25cadcf0d348510d73837e1aa5',
    name: 'Orbit Value Strategies',
  },
  {
    address: '0x010461c14e146ac35fe42271bdc1134ee31c703a',
    name: 'HLP Strategy A',
  },
  {
    address: '0x31ca8395cf837de08b24da3f660e77761dfb974b',
    name: 'HLP Strategy B',
  },
  {
    address: '0x654016a8c9fcf0c4cb7ed6078aba21f7f399f7b7',
    name: 'BredoStrategy',
  },
  {
    address: '0xb1505ad1a4c7755e0eb236aa2f4327bfc3474768',
    name: 'Bitcoin Moving Average Long/Short',
  },
  {
    address: '0xa6a34f0bf2ccea9a1ddf9e9a973f17c498dc5e40',
    name: 'FC Genesis - Quantum',
  },
  {
    address: '0x8231fdf9997c003a267374b45fb25c0455aa1dcb',
    name: 'AIQuantPulse',
  },
]

export const getHypercoreVaultRegistry = (): HypercoreVaultRegistryEntry[] =>
  HYPERCORE_VAULT_REGISTRY
